import { useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../context/authcontext';

interface UseTenantChangeOptions {
  onTenantChange?: () => void;
  refreshData?: () => void;
  clearData?: () => void;
}

export const useTenantChange = (options: UseTenantChangeOptions = {}) => {
  const { selectedTenantId } = useContext(AuthContext);
  const previousTenantId = useRef<string | null>(null);
  const { onTenantChange, refreshData, clearData } = options;

  useEffect(() => {
    // Skip on initial load when previousTenantId is null
    if (previousTenantId.current !== null && previousTenantId.current !== selectedTenantId) {
      // Clear existing data first
      if (clearData) {
        clearData();
      }
      
      // Trigger custom tenant change handler
      if (onTenantChange) {
        onTenantChange();
      }
      
      // Refresh data for new tenant
      if (refreshData) {
        // Small delay to ensure state is updated
        setTimeout(() => {
          refreshData();
        }, 100);
      }
    }
    
    // Update the previous tenant ID
    previousTenantId.current = selectedTenantId;
  }, [selectedTenantId, onTenantChange, refreshData, clearData]);

  return {
    currentTenantId: selectedTenantId,
    previousTenantId: previousTenantId.current,
    hasTenantChanged: previousTenantId.current !== null && previousTenantId.current !== selectedTenantId
  };
}; 